import { render, staticRenderFns } from "./ListTreatedRefillFille.vue?vue&type=template&id=32064908&scoped=true"
import script from "./ListTreatedRefillFille.vue?vue&type=script&lang=js"
export * from "./ListTreatedRefillFille.vue?vue&type=script&lang=js"
import style0 from "./ListTreatedRefillFille.vue?vue&type=style&index=0&id=32064908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32064908",
  null
  
)

export default component.exports